<template>
    <div style="position:relative">
        <div class="tableFilters">
            <div class="control">
                <div class="select">
                    <select v-model="length" @change="resetPagination()">
                        <option v-for="(records, index) in perPage" :key="index" :value="records">{{ records }}</option>
                    </select>
                </div>
            </div>
            <div class="inputcontainer">
                <input class="input" type="text" v-model="search" placeholder="Suchen..."
                       @input="resetPagination">
            </div>
            <slot></slot>
        </div>
        <datatable :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy" :client="true"
                   :key="key" :dataLoading="dataLoading">
            <tbody v-if="paginated.length === 0 && !dataLoading">
            <tr class="noData">{{ noData }}</tr>
            </tbody>
            <transition-group v-else name="fade" tag="tbody" :key="key">
                <tr v-for="(row, i) in paginated" :key="row+'_'+i"
                    :class="{'not_in_deallist':typeof row.in_deallist !== 'undefined' && row.in_deallist === 0,
                    'first_of_genre': isFirstOfGenre(row, i !== 0 ? paginated[i-1] : null)}">
                    <td :class="[column.name, {route: (typeof column.route !== 'undefined')}]"
                        v-for="(column, j) in columns"
                        :key="'td_'+i+'_'+j" @click="emitRowClicked($event, column, row)">
                        <div v-if="column.name === 'status'" class="flex" style="justify-content: center;">
                            <StatusDot v-bind="$attrs"
                                       :info="getDataForDynamicLink(column.name, row)"></StatusDot>
                        </div>
                        <DynamicLink v-else :data="getDataForDynamicLink(column.name, row)"></DynamicLink>
                    </td>
                </tr>
            </transition-group>
        </datatable>
        <pagination :pagination="pagination" :client="true" :filtered="filteredData"
                    @prev="previousPage"
                    @next="nextPage">
        </pagination>
    </div>
</template>

<script>

import Datatable from "./Datatable";
import Pagination from "./Pagination";
import DynamicLink from "./DynamicLink";
import StatusDot from "@/components/dataTable/StatusDot";

export default {
    name: "AdaTableClient",
    components: {StatusDot, DynamicLink, Pagination, Datatable},
    props: {
        rows: {type: Array, default: () => []},
        columns: {type: Array, default: () => []},
        transformers: {
            $each: {
                validator: function (value) {
                    return value.propName && value.transform
                }
            },
        },
        sortKey: String,
        dataLoading: {type: Boolean, default: false},
        searchData: Object,
        tableLength: {
            type: Number,
            default: 10,
        },
        noData: {
            type: String,
            default: 'Keine Daten'
        }
    },
    created() {
        this.pagination.total = this.rows.length;
    },
    data() {
        let sortOrders = {};
        this.columns.forEach((column) => {
            sortOrders[column.name] = column.name === this.sortKey ? 1 : -1;
        });
        let length = this.tableLength;
        return {
            key: 0,
            sortOrders: sortOrders,
            length: length,
            search: '',
            perPage: ['10', '25', '50'],
            tableData: {
                client: true,
            },
            pagination: {
                currentPage: 1,
                total: '',
                nextPage: '',
                prevPage: '',
                from: '',
                to: ''
            },
        }
    },
    methods: {
        previousPage() {
            --this.pagination.currentPage;
        },
        nextPage() {
            ++this.pagination.currentPage;
        },
        paginate(array, length, pageNumber) {
            this.pagination.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
            this.pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
            this.pagination.prevPage = pageNumber > 1 ? pageNumber : '';
            this.pagination.nextPage = array.length > this.pagination.to ? pageNumber + 1 : '';
            return array.slice((pageNumber - 1) * length, pageNumber * length);
        },
        resetPagination() {
            this.pagination.currentPage = 1;
            this.pagination.prevPage = '';
            this.pagination.nextPage = '';
        },
        sortBy(key) {
            this.resetPagination();
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        },
        transform: function (propName, row) {
            let value = row[propName];
            let transformer = this.getTransformer(propName);
            if (!transformer) {
                return value;
            } else {
                return transformer.transform(value, row);
            }
        },

        getTransformer: function (propName) {
            if (typeof this.transformers === 'undefined') {
                return null;
            }
            let transformer = null;
            for (let i = 0; i < this.transformers.length; i++) {
                if (this.transformers[i].propName === propName) {
                    transformer = this.transformers[i];
                    break;
                }
            }
            return transformer;
        },
        emitRowClicked(event, column, row) {
            this.$emit('rowClicked', {event: event, column: column, row: row});
        },
        getDataForDynamicLink(colName, row) {
            return {
                column: this.columns.find(x => x.name === colName),
                row: row,
                text: this.transform(colName, row)
            }
        },
        isFirstOfGenre(row, preRow) {
            return preRow === null || preRow.genre !== row.genre;
        }
    },
    computed: {
        filteredData() {
            let rows = this.rows;
            if (typeof this.searchData !== "undefined") {
                let visibility = [];
                if (typeof this.searchData.private !== "undefined" && this.searchData.private) visibility.push('private');
                if (typeof this.searchData.public !== "undefined" && this.searchData.public) visibility.push('public');
                if (typeof this.searchData.shared !== "undefined" && this.searchData.shared) visibility.push('shared');
                if (typeof this.searchData.group !== "undefined" && this.searchData.group !== null && this.searchData.group.id !== 0) {
                    rows = rows.filter(x => x.group.length !== 0 && x.group[0].id === this.searchData.group.id);
                }
                if (visibility.length !== 0) rows = rows.filter(x => visibility.includes(x.visibility));
            }
            if (this.search) {
                rows = rows.filter((row) => {
                    return Object.keys(row).some((key) => {
                        return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;
                    })
                });
            }
            let sortKey = this.sortKey;
            let order = this.sortOrders[sortKey] || 1;
            if (sortKey) {
                rows = rows.slice().sort((a, b) => {
                    let index = this.getIndex(this.columns, 'name', sortKey);
                    a = String(a[sortKey]).toLowerCase();
                    b = String(b[sortKey]).toLowerCase();
                    if (this.columns[index] && this.columns[index].type && this.columns[index].type === 'date') {
                        return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                    } else if (this.columns[index] && this.columns[index].type && this.columns[index].type === 'number') {
                        return (+a === +b ? 0 : (+a > +b ? 1 : -1)) * order;
                    } else if (this.columns[index] && this.columns[index].type && this.columns[index].type === 'naturalNumber') {
                        return (a.localeCompare(b, navigator.languages[0] || navigator.language, {
                            numeric: true,
                            ignorePunctuation: true
                        })) * order;
                    } else {
                        return (a === b ? 0 : (a > b ? 1 : -1)) * order;
                    }
                });
            }
            return rows;
        },
        paginated() {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        },
    },
    watch: {
        rows() {
            this.pagination.total = this.rows.length;
            this.key++
        },
        columns() {
            this.key++;
        },
        searchData() {
            this.key++;
        }
    }
};
</script>

<style lang="scss" scoped>
input {
    min-height: 40px;
    border: 1px solid #d0d4da;
    background: #fff;
    padding: .5rem;
    display: inline-block;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    font-size: 1em;
}

select {
    font-size: 1em;
    min-height: 40px;
    border: 1px solid #d0d4da;
    padding: .5rem;
    display: inline-block;
}


.control {
    display: inline-block;
    margin-right: 1rem;
}

.tableFilters {
    margin-bottom: 10px;
    display: inline-block;
}


*:focus {
    outline: none;
}

.icon-container {
    position: absolute;
    right: 10px;
    top: calc(50% - 10px);
}

.inputcontainer {
    position: relative;
    display: inline-block;
    margin-right: 1rem;
}

.table {
    overflow-x: scroll;
}

:deep( .container) {
    /* Background-color of the odd rows */
    tr:nth-child(odd) {
        background-color: #f6f7f8;
    }

    /* Background-color of the even rows */
    tr:nth-child(even) {
        background-color: #fff;
    }

    tr:hover {
        background-color: #eceef0;
    }
}

:deep(td:not(.route, .status) ){
    padding: 10px;
}

:deep( td.action ){
    text-align: right;
    padding-right: 20px;

    .icon {
        font-size: 20px;

        &:not(:first-child) {
            margin-left: 10px;
        }
    }
}

.noData {
    width: 100%;
    position: absolute;
    display: flex;
    background: #f6f7f8;
    padding: 10px;
    justify-content: center;
}


</style>